// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"private_toggleSwitch__GgA+R","true":"private_true__Oq21C","toggleHandle":"private_toggleHandle__nmXbX"};